import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, IconButton, Box, useMediaQuery, useTheme, Menu, MenuItem,
} from '@mui/material';
import { AccountCircle, Menu as MenuIcon, Dashboard as DashboardIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth, User } from '../../hooks/useAuth';
import { Sidebar } from './Sidebar';

interface HeaderProps {
  user?: User | null;
}

export const Header: React.FC<HeaderProps> = (props) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleMobileMenuToggle = () => setMobileMenuOpen(!mobileMenuOpen);
  const handleMobileMenuClose = () => setMobileMenuOpen(false);

  const handleUserMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDashboardClick = () => {
    handleUserMenuClose();
    if (isAuthenticated) {
      navigate('/admin/campaigns');
    } else {
      navigate('/admin/login');
    }
  };

  return (
    <>
      {isDesktop ? (
        <AppBar position='fixed' sx={{ zIndex: theme.zIndex.drawer + 1 }}>
          <Toolbar>
            <Typography variant='h6' component='div' sx={{ flexGrow: 1 }}>
              Emily
            </Typography>
            <Box display='flex' alignItems='center'>
              <Typography variant='body2' sx={{ mr: 2 }}>
                {props.user?.name || props.user?.email || 'User'}
              </Typography>
              <IconButton color='inherit' onClick={handleUserMenuOpen}>
                <AccountCircle />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleUserMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <MenuItem onClick={handleDashboardClick}>
                  <DashboardIcon fontSize='small' sx={{ mr: 1 }} />
                  Dashboard
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </AppBar>
      ) : (
        <AppBar position='fixed'>
          <Toolbar>
            <IconButton color='inherit' edge='start' onClick={handleMobileMenuToggle} sx={{ mr: 2 }}>
              <MenuIcon />
            </IconButton>
            <Typography variant='h6' component='div' sx={{ flexGrow: 1 }}>
              Emily
            </Typography>
            <IconButton color='inherit' onClick={handleUserMenuOpen}>
              <AccountCircle />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleUserMenuClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <MenuItem onClick={handleDashboardClick}>
                <DashboardIcon fontSize='small' sx={{ mr: 1 }} />
                Dashboard
              </MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
      )}
      {!isDesktop && (
        <Sidebar variant='temporary' open={mobileMenuOpen} onClose={handleMobileMenuClose} />
      )}
    </>
  );
};
